/* LINEお友達追加ポップアップ表示 */
window.addEventListener('load', function() {
  //LINE経由
  utm_source = getParam('utm_source');
  utm_medium = getParam('utm_medium');
  if(utm_source === 'line' && utm_medium != 'cpc'){
    sessionStorage.setItem('acs', 'on');
  }else{
 	// 1回目のアクセスかどうか
    if(sessionStorage.getItem('acs') === null) {
       // 1回目の場合はWebStorageを設定
       sessionStorage.setItem('acs', 'on');
       document.getElementById('popup-open').click();
    }
    var popup_mini = document.getElementById('popup_mini');
    popup_mini.addEventListener('click', function() {
      sessionStorage.setItem('popup_mini', 'on');
      $("#popup_mini").hide();
    }, false);

    if(sessionStorage.getItem('popup_mini') === null) {
      //ポップアップMINI表示
      $("#popup_mini").show();
    }
  }
}, false);

function getParam(name, url){
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/* ヘッダーナビスクロール */
$(function() {
  var $win = $(window),
      $main = $('.page-body-content'),
      $nav = $('.main-header'),
      navHeight = $nav.outerHeight(),
      footerHeight = $('.main-footer').outerHeight(),
      docmentHeight = $(document).height(),
      navPos = $nav.offset().top,
      fixedClass = 'is-fixed',
      hideClass = 'is-hide';

  $win.on('load scroll', function() {
    var value = $(this).scrollTop(),
        scrollPos = $win.height() + value;

    if ( value > navPos ) {
      if ( docmentHeight - scrollPos <= footerHeight ) {
        //$nav.addClass(hideClass);
      } else {
        //$nav.removeClass(hideClass);
      }
      $nav.addClass(fixedClass);
      //$main.css('margin-top', navHeight);
    } else {
      $nav.removeClass(fixedClass);
      //$main.css('margin-top', '0');
    }
  });
});